import { useLocalizedString } from '@volvo-cars/react-locale-provider';
import { label as labelTranslations } from '../../i18n/back/i18n';
import { IconButton, type LocalizedIconButtonProps } from '../icon-button';

/**
 * A button for going back to the previous item, page, or step.
 * Uses the useLocale hook from LocaleProvider context to provide an accessible label
 * based on the current locale, or wraps with one if `locale` is provided.
 */
export function BackIconButton(props: LocalizedIconButtonProps) {
  const label = useLocalizedString(labelTranslations);
  return <IconButton icon="arrow-back" aria-label={label} {...props} />;
}
